import request from '@/utils/request'

// 获取I类切口手术部位感染数据列表
export function getOneSurveryList(params = {}) {
  return request({
    url: '/one-survery/list',
    method: 'get',
    params
  })
}

// 保存I类切口手术部位感染数据
export function saveOneSurvery(data) {
  return request({
    url: '/one-survery/save',
    method: 'post',
    data
  })
}

// 更新I类切口手术部位感染数据
export function updateOneSurvery(data) {
  return request({
    url: '/one-survery/update',
    method: 'put',
    data
  })
}

// 删除I类切口手术部位感染数据
export function deleteOneSurvery(id) {
  return request({
    url: `/one-survery/delete/${id}`,
    method: 'delete'
  })
} 